import { Button } from "@mui/material";
import React from "react";
import LoadingButton from "./LoadingButton";
import "../styles/toggle.tabs.css";

export interface ToggleTabProps {
  okText?: string;
  cancelText?: string;
  title: string;
  element: React.ReactNode;
  onCancel?: () => Promise<unknown>;
  onOk?: () => Promise<unknown>;
  show: boolean;
  extraAction?: (
    call: React.Dispatch<React.SetStateAction<ToggleTabProps>>,
    tab: ToggleTabProps,
  ) => JSX.Element;
  hideCancel?: boolean;
}

let resolve: (value?: unknown) => void, reject: (reason?: any) => void;

const defaultTab = {
  title: "",
  element: <i></i>,
  show: false,
  onOk: async () => {},
};

const VisibleTabs = (props: { children: React.ReactNode }) => {
  const [tab, setTab] = React.useState<ToggleTabProps>(defaultTab);

  React.useEffect(() => {
    window.webApp = window.webApp || {};
    window.webApp.setTab = (param) => {
      let scrollTop = window.scrollY;
      setTab({ ...param, show: true });
      return new Promise((rs, rj) => {
        resolve = rs as any;
        reject = rj as any;
      })
        .then((res: any) => {
          window.scrollTo(0, scrollTop);
          return res;
        })
        .catch((e) => {
          window.scrollTo(0, scrollTop);
          throw e;
        });
    };
  }, []);

  const onOk = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      if (tab.onOk) {
        const res = await tab.onOk();
        resolve(res);
      }
      setTab({ ...tab, show: false, element: <i></i> });
      resolve();
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const onCancel = async () => {
    if (!tab.onCancel) {
      setTab({ ...tab, show: false, element: <i></i> });
      reject("canceled");
      return;
    }
    try {
      const res = await tab.onCancel();
      setTab({ ...tab, show: false, element: <i></i> });
      resolve(res);
    } catch (error) {
      console.error(error);
      throw error;
      // todo display error message
    }
  };
  return (
    <div className="relative">
      <div style={{ display: tab.show ? "none" : "block" }}>
        {props.children}
      </div>
      <div style={{ display: tab.show ? "block" : "none" }}>
        {tab.element}
        <div className="btns-con center-wrapper">
          {tab.extraAction && tab.extraAction(setTab, { ...tab })}
          {!tab.hideCancel && (
            <Button
              variant="outlined"
              className="margin-r-normal margin-l-normal"
              onClick={onCancel}
            >
              {tab.cancelText || "Cancel"}
            </Button>
          )}
          {tab.onOk && (
            <LoadingButton onClick={onOk}>
              {tab.okText || "Save Changes"}
            </LoadingButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisibleTabs;
